"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var date_picker_1 = tslib_1.__importDefault(require("antd/es/date-picker"));

exports.DatePicker = function (_a) {
  var className = _a.className,
      _a$format = _a.format,
      format = _a$format === void 0 ? 'DD/MM/YYYY' : _a$format,
      props = tslib_1.__rest(_a, ["className", "format"]);

  return React.createElement(date_picker_1["default"], Object.assign({
    format: format,
    dropdownClassName: 'clp-datepicker',
    className: "clp-datepicker__input ".concat(className)
  }, props));
};